/**
 * Mapa kluczy zakładek na ludzkie etykiety wyświetlane np. w „← Wróć do …"
 * Synchronizowana z TAB_TO_PATH w useTabRouting.js.
 */
export const TAB_LABELS = {
  home: 'Strona główna',
  add: 'Napiwki',
  communicator: 'Komunikator',
  summary: 'Podsumowanie',
  reports: 'Raporty',
  waiters: 'Pracownicy',
  billard: 'Bilard',
  glass: 'Szkła',
  kitchen_losses: 'Straty',
  kitchen_losses_add: 'Dodaj stratę',
  kitchen_losses_reports: 'Raporty strat',
  kitchen_losses_products: 'Produkty strat',
  warehouse_protocols: 'Protokoły magazynowe',
  beer_cleaning: 'Czyszczenie piwa',
  training: 'Szkolenia',
  materials: 'Materiały',
  briefing: 'Informacje dnia',
  sales: 'Sprzedaż',
  promotions: 'Promocje',
  marketing: 'Marketing',
  deliveries: 'Dostawy',
  clothing: 'Odzież',
  graphic_projects: 'Grafika',
  export: 'Eksport',
  changelog: 'Nowości',
  tutorial: 'Samouczek',
  manager: 'Manager',
  recruitment: 'Rekrutacja / dni próbne',
  recruitment_apps: 'Rekrutacja internetowa',
  reminders: 'Przypomnienia',
  manager_analytics: 'Analizy managerskie',
  manager_performance: 'Panel kierownika restauracji',
  team_engagement: 'Zaangażowanie zespołu',
  cash: 'Kasa',
  inventory: 'Inwentaryzacje',
  monthly_closing: 'Zamknięcie miesiąca',
  reviews: 'Opinie',
  delikatesy: 'Delikatesy',
  forms: 'Formularze',
  development: 'Zespół rozwoju',
  daily_settlement: 'Rozliczenia Dzienne',
  settings: 'Ustawienia',
};
